<template>
  <section class="hero is-success is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div
          class="column is-4 is-offset-4 is-4-tablet is-4-desktop is-4-widescreen"
        >
          <div class="box">
            <figure class="image is-4by1">
              <img src="@/assets/abalogix_transparent.png" />
            </figure>
            <form class="login" @submit.prevent="login">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    required
                    autofocus
                    class="input is-large"
                    :class="{ 'is-danger': error.username }"
                    v-model="username"
                    type="username"
                    placeholder="Your Username"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                </div>
                <p class="help is-danger" v-if="error.username">
                  Invalid login
                </p>
              </div>

              <div class="field">
                <div class="control has-icons-left">
                  <input
                    required
                    minlength="8"
                    class="input is-large"
                    :class="{ 'is-danger': error.password }"
                    v-model="password"
                    type="password"
                    placeholder="***********"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
              </div>
              <button
                class="button is-block is-link is-large is-fullwidth"
                type="submit"
              >
                Login
              </button>
            </form>
          </div>
          <p class="has-text-grey">
            <router-link to="/register">Register Account</router-link>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { accountMixin } from "@/mixins/account.js";

export default {
  data() {
    return {
      username: "",
      password: "",
      error: {
        username: false,
        password: false
      }
    };
  },
  mixins: [accountMixin],
  methods: {
    login: function() {
      this.error.username = false;
      this.error.password = false;
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login", { username, password })
        .then(() => {
          //Nested Axios promise such that the HTTP call returns populating the account object
          this.getAccountDetails().then(() => {
            this.account.approved_products.milelogix_for_teams
              ? this.$router.push("/milelogix-for-teams")
              : this.$router.push("/milelogix");
          });
        })
        .catch(httpError => {
          if (httpError.response) {
            this.error.username = true;
            this.error.password = true;
          }
        });
    }
  }
};
</script>

<style scoped>
html,
body {
  font-family: "Open Sans", serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}
</style>
